import React from 'react';
import { FormFieldMetadataContext } from '../components/FormField';
import { FormFieldGroupContext } from '../components/FormFieldGroup';
export const useFieldContexts = (props)=>{
    var _group_description, _field_description, _field_error, _group_legend, _field_label;
    const { controlId, elements: field } = React.useContext(FormFieldMetadataContext);
    const { disabled, elements: group } = React.useContext(FormFieldGroupContext);
    const describedby = [
        ((_group_description = group.description) === null || _group_description === void 0 ? void 0 : _group_description.present) && group.description.id,
        ((_field_description = field.description) === null || _field_description === void 0 ? void 0 : _field_description.present) && field.description.id,
        ((_field_error = field.error) === null || _field_error === void 0 ? void 0 : _field_error.present) && field.error.id
    ].filter(Boolean).join(' ').trim();
    const labelledby = [
        ((_group_legend = group.legend) === null || _group_legend === void 0 ? void 0 : _group_legend.present) && group.legend.id,
        ((_field_label = field.label) === null || _field_label === void 0 ? void 0 : _field_label.present) && field.label.id
    ].filter(Boolean).join(' ').trim();
    var _props_disabled, _ref, _props_invalid;
    return {
        disabled: (_ref = (_props_disabled = props.disabled) !== null && _props_disabled !== void 0 ? _props_disabled : disabled) !== null && _ref !== void 0 ? _ref : false,
        // certain fields have an `invalid` prop, and it should take precedence over whether an error message is provided
        'aria-invalid': (_props_invalid = props.invalid) !== null && _props_invalid !== void 0 ? _props_invalid : field.error.present,
        // `invalid` is not a valid html attribute though, so it should not be passed to the DOM
        invalid: undefined,
        // let users override generated aria-* label and description props
        'aria-describedby': props['aria-describedby'] || describedby || undefined,
        'aria-labelledby': props['aria-labelledby'] || labelledby || undefined,
        id: controlId
    };
};

//# sourceMappingURL=useFieldContexts.js.map